import { useState } from "react";
import { Link } from "react-router-dom";
import Constrants from "../constrants/constrant";
import { useToast } from "../context/ToastProvider";
import { useSettings } from "../context/SettingsProvider";

function ForgotPassword() {
    const { addToast } = useToast();
    const { settings } = useSettings();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await Constrants.post("/forgot-password", { email });

            setSuccess(true);
            addToast(res.data.message, "success", 5000);
        } catch (err) {
            console.error("Forgot password error:", err);

            if (err.response?.data?.message) {
                addToast(err.response.data.message, "error");
            } else if (err.response?.data?.errors) {
                const errors = Object.values(err.response.data.errors).flat();
                addToast(errors.join(", "), "error");
            } else {
                addToast("Failed to send reset link. Please try again.", "error");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="main-content">
            <div className="auth-container">
                <div className="auth-card active">
                    <div className="auth-header">
                        <div className="auth-logo">
                            <div className="logo-icon" style={{ width: "48px", height: "48px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white">
                                    <path d="M0 0h24v24H0V0z" fill="none" /><path d="M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39s-4.66 1.97-4.66 4.39c0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94s3.08 1.32 3.08 2.94c0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.10-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z" />
                                </svg>
                            </div>
                        </div>
                        <h1 className="auth-title">Forgot Password?</h1>
                        <p className="auth-subtitle">Enter your email to reset your password</p>
                    </div>

                    {success ? (
                        <div style={{ padding: "30px", textAlign: "center" }}>
                            <div style={{
                                background: "#d4edda",
                                border: "1px solid #c3e6cb",
                                color: "#155724",
                                padding: "20px",
                                borderRadius: "8px",
                                marginBottom: "20px"
                            }}>
                                <h3 style={{ margin: "0 0 10px 0" }}>Check Your Email</h3>
                                <p style={{ margin: 0 }}>
                                    We've sent a password reset link to <strong>{email}</strong>.
                                    Please check your inbox and follow the instructions.
                                </p>
                            </div>
                            <Link to="/login" className="auth-btn primary" style={{ textDecoration: "none", display: "inline-block" }}>
                                Back to Login
                            </Link>
                        </div>
                    ) : (
                        <form className="auth-form" onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="email" className="form-label">Email Address</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-input"
                                    placeholder="Enter your email"
                                    required
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>

                            <button type="submit" className="auth-btn primary" disabled={loading}>
                                {loading ? "Sending..." : "Send Reset Link"}
                            </button>

                            <div className="auth-footer" style={{ marginTop: "20px" }}>
                                Remember your password? <Link to="/login" className="link-text">Sign in</Link>
                            </div>
                        </form>
                    )}
                </div>
            </div>

            <section className="section">
                <div className="section-header">
                    <h2 className="section-title">Need Help?</h2>
                </div>
                <div className="categories-grid">
                    <div className="category-card">
                        <div className="category-icon" style={{ background: "linear-gradient(45deg, #667eea, #764ba2)" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white">
                                <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
                            </svg>
                        </div>
                        <div className="category-name">Check your spam folder</div>
                    </div>

                    <div className="category-card">
                        <div className="category-icon" style={{ background: "linear-gradient(45deg, #f093fb, #f5576c)" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white">
                                <path d="M0 0h24v24H0V0z" fill="none" /><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                            </svg>
                        </div>
                        <div className="category-name">Link expires in 1 hour</div>
                    </div>

                    <div className="category-card">
                        <div className="category-icon" style={{ background: "linear-gradient(45deg, #4caf50, #8bc34a)" }}>
                            <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="white">
                                <path d="M0 0h24v24H0V0z" fill="none" /><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z" />
                            </svg>
                        </div>
                        <div className="category-name">Secure password reset</div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default ForgotPassword;
